export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 3